__turbopack_context__.v({
  "className": "ibm_plex_sans_27fcd869-module__jDIBdq__className",
});
